import React from "react";
import "./productStyles.css";
import DropzoneFSA_LFD from "../DropzoneFSA_LFD";
import background from "../assets/lfsa.png";
import DROPZONE_DATA from "../DROPZONE_DATA";
import "./productStyles.css"; //* migrate styles added by js for the products to this stylesheet

export default function L_fsa({
  handleWarningMessageText,
  handleDropzoneChanges,
  handleContinueButtonDisabled
}) {
  // const isLFD = true;

  return (
    <div className="landscapeProductContainer">
      <img
        alt=""
        className="backgroundImageContainer landscape"
        src={background}
      ></img>
      <div className="landscapeFullScreen">
        <DropzoneFSA_LFD
          acceptedFileTypeString={DROPZONE_DATA.data.imageAndVideo}
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          droppedFileType="landscape"
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      </div>
    </div>
  );
}
